import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild} from "@angular/core";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {PhotovoltaikcheckBackendService} from "../services/backend.service";
import {PhotovoltaikcheckRequestService} from "../services/request.service";

/**
 * Details of the costs and savings for the selected configurations.
 */
@Component({
    selector: 'app-photovoltaikcheck-ergebnis-cost',
    templateUrl: './ergebnis.cost.component.html',
    providers: [],
    standalone: false
})
export class ErgebnisCostComponent implements AfterViewInit {
  /**
   * Placeholders that we got from the backend
   */
  @Input() placeholder: {[key: string]: string | number};

  /**
   * Ratings from the backend
   */
  @Input() ratings: {[key: string]: string | number};

  /**
   * textprefix for all texts
   */
  @Input() textkeyPrefix: string;

  /**
   * request object
   */
  @Input() anfrage: PhotovoltaikcheckAnfrage;

  /**
   * Event when the result is changed because of the change of the electricity price.
   */
  @Output() resultChanged: EventEmitter<void> = new EventEmitter<void>();

  /**
   * the back and front card element
   */
  @ViewChild('backCard') backCard: ElementRef;
  @ViewChild('frontCard') frontCard: ElementRef;

  /**
   * min height of the cards
   */
  cardMinHeight: number = null;

  /**
   * if we have some errorss
   */
  formError: string;

  /**
   * Some boolean toggle to show/hide some items
   */
  toggle = {
    helpCost: false,
    helpSaving: false,
    maintenance: false,
    price: false,
    loading: false
  };

  /**
   * constructor
   * @param backendService
   * @param requestService
   */
  constructor(private backendService: PhotovoltaikcheckBackendService, private requestService: PhotovoltaikcheckRequestService) {
  }

  /**
   * @inheritdoc
   */
  ngAfterViewInit() {
    // init card height
    setTimeout(() => this.updateHeights(), 1000);
  }

  /**
   * update card height
   */
  @HostListener('window:resize', [])
  updateHeights(): void {
    // price
    this.cardMinHeight = this.frontCard.nativeElement.offsetHeight;
    if(this.toggle.price) {
      this.cardMinHeight = this.backCard.nativeElement.offsetHeight;
    }
  }

  /**
   * flip some info element form
   */
  flipInfo(info: string): void {
    this.toggle[info] = !this.toggle[info];

    setTimeout(() => this.updateHeights());
  }

  /**
   * Submit the form and recalculate the configuration
   */
  saveForm(data: {[key: string]: any}): void {
    this.formError = null;
    // update card height
    this.updateHeights();

    // set data from form on anfrage
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};

    this.saveData();
  }

  /**
   * save data on anfrage and server. Close the flipper afterwards
   */
  saveData(): void {
    // send data to backend and show result if ready
    this.toggle.loading = true;
    this.backendService.getRequestId().subscribe(requestId => {
      this.backendService.result(this.anfrage, requestId).subscribe(result => {
        // stop lading animation
        this.toggle.loading = false;

        // save result
        this.anfrage.result = result;
        this.requestService.setAnfrage(this.anfrage);

        this.resultChanged.emit();

        // flip back
        this.toggle.price = false;
      });
    });
  }
}
